/** 产品/工序委外收料 confirmReceive 入参构建（cooperativeReceiveConfirmDto） */

export const RECEIVE_EXCEPTION_TYPE = {
  NORMAL: '正常',
  SHORT: '短收',
  DAMAGED: '破损',
  BATCH_MISMATCH: '批次号不符',
}

export const RECEIVE_EXCEPTION_TYPE_OPTIONS = [
  { label: '正常', value: RECEIVE_EXCEPTION_TYPE.NORMAL },
  { label: '短收', value: RECEIVE_EXCEPTION_TYPE.SHORT },
  { label: '破损', value: RECEIVE_EXCEPTION_TYPE.DAMAGED },
  { label: '批次号不符', value: RECEIVE_EXCEPTION_TYPE.BATCH_MISMATCH },
]

export function normalizeExceptionType(type) {
  const codeMap = {
    0: RECEIVE_EXCEPTION_TYPE.NORMAL,
    1: RECEIVE_EXCEPTION_TYPE.SHORT,
    2: RECEIVE_EXCEPTION_TYPE.DAMAGED,
    3: RECEIVE_EXCEPTION_TYPE.BATCH_MISMATCH,
  }
  if (type === 0 || type === 1 || type === 2 || type === 3) {
    return codeMap[type]
  }
  return type || RECEIVE_EXCEPTION_TYPE.NORMAL
}

export function isNormalReceiveException(type) {
  return (
    type === undefined ||
    type === null ||
    type === '' ||
    type === RECEIVE_EXCEPTION_TYPE.NORMAL ||
    type === 0
  )
}

export function getRequisitionDocId(source) {
  if (!source) return null;
  return (
    source.requisitionDocId ||
    source.outsourcingRequisitionDocId ||
    source.processOutsourcingRequisitionDocId ||
    source.materialRequisitionId ||
    null
  );
}

export function getRequisitionDetailId(detail) {
  if (!detail) return null;
  return (
    detail.detailId ||
    detail.outsourcingRequisitonDocDetailId ||
    detail.outsourcingRequisitionDocDetailId ||
    detail.processOutsourcingRequisitionDocDetailId ||
    detail.processOutsourcingRequisitonDocDetailId ||
    detail.materialRequisitionDocDetailId ||
    null
  );
}

export function parseExceptionFileList(value) {
  if (!value) return []
  if (Array.isArray(value)) return value
  try {
    const list = JSON.parse(value)
    return Array.isArray(list) ? list : []
  } catch (error) {
    return []
  }
}

export function serializeExceptionFileList(fileList) {
  if (!fileList || !fileList.length) return undefined
  return JSON.stringify(fileList)
}

export function initReceiveDetailRow(item) {
  const applyQty = Number(item.baseRequisitionQuantity) || 0
  const receivedQty = getDetailReceivedQuantity(item)
  const valueCanReceiveQuantity = Math.max(0, applyQty - receivedQty)
  const row = {
    ...item,
    detailId: getRequisitionDetailId(item),
    _confirmedReceiveQuantity: receivedQty,
    valueCanReceiveQuantity,
    valueActualReceiveQuantity: valueCanReceiveQuantity,
    valueBatchNumber: item.valueBatchNumber || '',
    valueExceptionType: normalizeExceptionType(item.valueExceptionType),
    valueExceptionRemark: item.valueExceptionRemark || '',
    _exceptionFiles: parseExceptionFileList(item.valueExceptionFileList),
  }
  return row
}

export function initReceiveForm({ detailList = [], baseReceiveDate, baseReceiverName } = {}) {
  return {
    baseReceiveDate,
    baseReceiverName: baseReceiverName || '',
    detailList: (detailList || []).map((item) => initReceiveDetailRow(item)),
  }
}

/** 发料明细中已确认的收料数量（valueActualReceiveQuantity） */
export function getDetailReceivedQuantity(item) {
  if (!item) return 0
  if (item._confirmedReceiveQuantity != null && item._confirmedReceiveQuantity !== '') {
    return Number(item._confirmedReceiveQuantity) || 0
  }
  const actual = item.valueActualReceiveQuantity
  if (actual != null && actual !== '') {
    return Number(actual) || 0
  }
  return 0
}

/** @deprecated 使用 getDetailReceivedQuantity */
export function getConfirmedReceiveQuantity(item) {
  return getDetailReceivedQuantity(item)
}

/** 可收料数量 = 申请数量 - 已收料数量 */
export function getReceivableQuantity(item) {
  if (!item) return 0
  const applyQty = Number(item.baseRequisitionQuantity) || 0
  const receivedQty = getDetailReceivedQuantity(item)
  return Math.max(0, applyQty - receivedQty)
}

export function validateReceiveForm(form) {
  if (!form.baseReceiveDate) {
    return '请选择收料日期'
  }
  if (!form.baseReceiverName || !String(form.baseReceiverName).trim()) {
    return '请填写收料人'
  }
  if (!form.detailList || !form.detailList.length) {
    return '暂无发料明细，无法收料'
  }
  for (let i = 0; i < form.detailList.length; i++) {
    const item = form.detailList[i]
    const rowNo = i + 1
    if (!getRequisitionDetailId(item)) {
      return `第 ${rowNo} 行缺少明细标识`
    }
    if (
      item.valueActualReceiveQuantity === '' ||
      item.valueActualReceiveQuantity == null
    ) {
      return `第 ${rowNo} 行请填写收料数量`
    }
    if (Number(item.valueActualReceiveQuantity) < 0) {
      return `第 ${rowNo} 行收料数量不能小于 0`
    }
    if (!isNormalReceiveException(item.valueExceptionType)) {
      const hasRemark = item.valueExceptionRemark && String(item.valueExceptionRemark).trim()
      const hasFiles = item._exceptionFiles && item._exceptionFiles.length
      if (!hasRemark && !hasFiles) {
        return `第 ${rowNo} 行异常状态需填写异常说明或上传附件`
      }
    }
  }
  return ''
}

export function buildConfirmReceivePayload({
  requisitionDocId,
  detailList = [],
  baseReceiveDate,
  baseReceiverName,
}) {
  return {
    cooperativeReceiveConfirmDto: {
      requisitionDocId,
      baseReceiveDate,
      baseReceiverName,
      detailList: detailList.map((item) => {
        const isNormal = isNormalReceiveException(item.valueExceptionType)
        const fileList = item._exceptionFiles || []
        return {
          detailId: getRequisitionDetailId(item),
          valueActualReceiveQuantity: item.valueActualReceiveQuantity,
          valueBatchNumber: item.valueBatchNumber || undefined,
          valueExceptionType: isNormal ? undefined : item.valueExceptionType,
          valueExceptionRemark: isNormal
            ? undefined
            : item.valueExceptionRemark || undefined,
          valueExceptionFileList: isNormal
            ? undefined
            : serializeExceptionFileList(fileList),
        }
      }),
    },
  }
}

/** 供应商收料确认状态（statusSupplierConfirm） */
export const SUPPLIER_CONFIRM_STATUS = {
  NONE: 0,
  PARTIAL: 1,
  COMPLETE: 2,
}

export const SUPPLIER_CONFIRM_STATUS_OPTIONS = [
  {
    label: '未收料',
    value: SUPPLIER_CONFIRM_STATUS.NONE,
    color: 'white',
    backGroundColor: 'rgb(102, 102, 102)',
  },
  {
    label: '部分收料',
    value: SUPPLIER_CONFIRM_STATUS.PARTIAL,
    color: 'white',
    backGroundColor: 'rgb(79,129,246)',
  },
  {
    label: '完全收料',
    value: SUPPLIER_CONFIRM_STATUS.COMPLETE,
    color: 'white',
    backGroundColor: 'rgb(106, 168, 79)',
  },
]

/** 收料状态筛选 → outsorRequisitionDocFilter.statusSupplierConfirm */
export function buildSupplierConfirmStatusFilter(statusSupplierConfirm) {
  if (
    statusSupplierConfirm === '' ||
    statusSupplierConfirm === null ||
    statusSupplierConfirm === undefined
  ) {
    return {}
  }
  return { statusSupplierConfirm: Number(statusSupplierConfirm) }
}

export function getSupplierConfirmStatus(source) {
  if (!source) return undefined
  const value = source.statusSupplierConfirm ?? source.status_supplier_confirm
  if (value === undefined || value === null || value === '') return undefined
  return Number(value)
}

/** 从单据头或明细行解析供应商确认状态，取最高进度 */
export function resolveSupplierConfirmStatus(doc, detailList = []) {
  const sources = [doc, ...(detailList || [])]
  let maxStatus
  for (const source of sources) {
    const status = getSupplierConfirmStatus(source)
    if (status === undefined) continue
    if (maxStatus === undefined || status > maxStatus) {
      maxStatus = status
    }
  }
  return maxStatus
}

export function isSupplierConfirmedStatus(doc, detailList = []) {
  const status = resolveSupplierConfirmStatus(doc, detailList)
  return (
    status === SUPPLIER_CONFIRM_STATUS.PARTIAL ||
    status === SUPPLIER_CONFIRM_STATUS.COMPLETE
  )
}

/** 明细是否已有收料确认结果（接口可能未返回 statusSupplierConfirm） */
export function detailHasReceiveConfirmData(item) {
  if (!item) return false
  const receiveFields = [
    'valueActualReceiveQuantity',
    'valueBatchNumber',
    'valueExceptionRemark',
    'valueExceptionType',
    'valueExceptionFileList',
  ]
  return receiveFields.some(
    (key) => item[key] !== undefined && item[key] !== null
  )
}

export function hasReceiveConfirmDetailData(detailList = []) {
  return (detailList || []).some((item) => detailHasReceiveConfirmData(item))
}

/** 未收料(0)或部分收料(1)时可收料；完全收料(2)不可收料 */
export function canConfirmReceive(source) {
  if (!source) return false
  const supplierConfirm = getSupplierConfirmStatus(source)
  if (supplierConfirm === undefined) return false
  if (supplierConfirm === SUPPLIER_CONFIRM_STATUS.COMPLETE) return false
  return (
    supplierConfirm === SUPPLIER_CONFIRM_STATUS.NONE ||
    supplierConfirm === SUPPLIER_CONFIRM_STATUS.PARTIAL
  )
}

/** 部分/完全收料时可撤销收料 */
export function canCancelReceiveConfirm(source) {
  if (!source) return false
  const status = getSupplierConfirmStatus(source)
  return (
    status === SUPPLIER_CONFIRM_STATUS.PARTIAL ||
    status === SUPPLIER_CONFIRM_STATUS.COMPLETE
  )
}

export function buildCancelReceiveConfirmPayload(requisitionDocId) {
  return {
    cooperativeReceiveConfirmDto: {
      requisitionDocId,
    },
  }
}
